<template lang="pug">
label.checkbox(:class="{ checked }") {{ label }}
  input(type="checkbox", v-model="checked")
</template>
<script>
export default {
  name: 'checkbox',
  props: {
    label: String,
    value: Boolean
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
label.checkbox {
  padding-left: 20px;
  height: 15px;
  display: inline-block;
  line-height: 15px;
  font-size: 15px;
  vertical-align: middle;
  cursor: pointer;
  background: no-repeat left center
    url("data:image/svg+xml;charset%3Dutf8,%3Csvg version%3D'1.1' xmlns%3D'http://www.w3.org/2000/svg' xmlns:xlink%3D'http://www.w3.org/1999/xlink' x%3D'0px' y%3D'0px'	 viewBox%3D'-467 269.6 23.4 23.4' style%3D'enable-background:new -467 269.6 23.4 23.4;' xml:space%3D'preserve'%3E%3Cstyle type%3D'text/css'%3E	.st0{fill:none;stroke:%23dadada;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}%3C/style%3E%3Cpath class%3D'st0' d%3D'M-461,283.1c0,0,2.6,0.4,5.1,3.8c0,0,0.4-7,5.7-12'/%3E%3C/svg%3E");
  -webkit-touch-callout: none;
  user-select: none;
  border: 1px solid transparent;
  &.block {
    display: block;
    margin-bottom: 0.5rem;
    text-align: left;
  }
  &.checked {
    background-image: url("data:image/svg+xml;charset%3Dutf8,%3Csvg version%3D'1.1' xmlns%3D'http://www.w3.org/2000/svg' xmlns:xlink%3D'http://www.w3.org/1999/xlink' x%3D'0px' y%3D'0px'	 viewBox%3D'-467 269.6 23.4 23.4' style%3D'enable-background:new -467 269.6 23.4 23.4;' xml:space%3D'preserve'%3E%3Cstyle type%3D'text/css'%3E	.st0{fill:none;stroke:orange;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}%3C/style%3E%3Cpath class%3D'st0' d%3D'M-461,283.1c0,0,2.6,0.4,5.1,3.8c0,0,0.4-7,5.7-12'/%3E%3C/svg%3E");
    border-bottom-color: orange;
  }
  input {
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  }
}
</style>
